import { datadogRum } from '@datadog/browser-rum';

/**
 * Client-side error logger. We do not use the *.client naming convention,
 * for compatibility with components like ErrorBoundaries that are also
 * rendered on the server.
 */
export const logError = (error: unknown, context?: object) => {
  datadogRum.addError(error, context);
  console.error(error, context); // eslint-disable-line no-restricted-syntax
};
